var pug = require("!../../../../node_modules/pug-runtime/index.js");

function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (confirm, ignore, message, title) {
buf.push("<div class=\"confirmation-modal\">");
if ( title)
{
buf.push("<h2 class=\"confirmation-modal__title\">" + (jade.escape(null == (jade_interp = title) ? "" : jade_interp)) + "</h2>");
}
if ( message)
{
buf.push("<div class=\"confirmation-modal__message\">" + (jade.escape(null == (jade_interp = message) ? "" : jade_interp)) + "</div>");
}
if ( confirm || ignore)
{
buf.push("<div class=\"confirmation-modal__actions\"><a" + (jade.attr("href", confirm && confirm.href || undefined, true, true)) + " class=\"avant-garde-button-black is-block js-confirmation-confirm analytics-confirmation-confirm\">" + (jade.escape(null == (jade_interp = confirm && confirm.label || 'OK') ? "" : jade_interp)) + "</a>");
if ( ignore)
{
buf.push("<a" + (jade.attr("href", ignore && ignore.href || undefined, true, true)) + " class=\"avant-garde-button-white is-block js-confirmation-ignore analytics-confirmation-ignore\">" + (jade.escape(null == (jade_interp = ignore && ignore.label || 'Maybe Later') ? "" : jade_interp)) + "</a>");
}
buf.push("</div>");
}
buf.push("</div>");}.call(this,"confirm" in locals_for_with?locals_for_with.confirm:typeof confirm!=="undefined"?confirm:undefined,"ignore" in locals_for_with?locals_for_with.ignore:typeof ignore!=="undefined"?ignore:undefined,"message" in locals_for_with?locals_for_with.message:typeof message!=="undefined"?message:undefined,"title" in locals_for_with?locals_for_with.title:typeof title!=="undefined"?title:undefined));;return buf.join("");
};
module.exports = template;